<template>
    <div class="" >
	    <div style="display: flex">
		    <div>
			    <app-btn style="" :loading="runningReport === 'invoice'" :disabled="!!runningReport" @click="getInvoiceReport">
				    Get Invoice Report
			    </app-btn>
			    <app-fab-btn iconName="icon-download" :loading="runningReport === 'download-invoice'" :disabled="!!runningReport" @click="downloadInvoiceReport" />
		    </div>
		    <div >
			    <app-btn style="" :loading="runningReport === 'unpaid'" :disabled="!!runningReport" @click="getUnpaidInvoiceReport">
				    Get Unpaid Invoice Report
			    </app-btn>
			    <app-fab-btn iconName="icon-download" :loading="runningReport === 'download-unpaid'" :disabled="!!runningReport" @click="downloadUnpaidInvoiceReport" />
		    </div>
		    <div >
			    <app-btn style="" :loading="runningReport === 'missing'" :disabled="!!runningReport" @click="getMissingInvoiceReport">
				    Get Missing Invoice Report
			    </app-btn>
			    <app-fab-btn iconName="icon-download" :loading="runningReport === 'download-missing'" :disabled="!!runningReport" @click="downloadMissingInvoiceReport" />
		    </div>
		    <div >
			    <app-btn style="" :loading="runningReport === 'unsent'" :disabled="!!runningReport" @click="getUnsentInvoiceReport">
				    Get Unsent Invoice Report
			    </app-btn>
			    <app-fab-btn iconName="icon-download" :loading="runningReport === 'download-unsent'" :disabled="!!runningReport" @click="downloadUnsentInvoiceReport" />
		    </div>
		    <div >
			    <app-btn style="" :loading="runningReport === 'shadow'" :disabled="!!runningReport" @click="getShadowInvoiceReport">
				    Get Shadow Invoice Report
			    </app-btn>
			    <app-fab-btn iconName="icon-download" :loading="runningReport === 'download-shadow'" :disabled="!!runningReport" @click="downloadShadowInvoiceReport" />
		    </div>
	    </div>
	    
	    <div v-if="currentReport">
		    <app-card hide-header class="mb-4 mt-4 pa-4">
			    <div v-if="currentReport === 2" >
				    <div>There are currently <strong style="color: #07aaf4">{{reportRows.length}}</strong> Unpaid Invoices</div>
				    
				    <div class="pt-2">
					    <div style="font-weight: bold">Unpaid Invoice Report Description</div>
					    <p>The Unpaid Invoice Report shows all invoices that have been created that have not been paid.</p>
				    </div>
				    
				    <div style="display: flex; gap: .25rem">
					    <div>Due Date: </div>
					
					    <app-chip color="red" label small>days past due</app-chip>
					    <app-chip color="green" label small>today</app-chip>
					    <app-chip color="blue" label small>days out</app-chip>
				    </div>
				    <v-divider class="mt-2"/>
				    <div v-if="unpaidInvoiceReportStats" class="mt-2">
					    <div>Total Invoice Amount: {{unpaidInvoiceReportStats.totalAmount}}</div>
					    <div class="mt-2">Filtered Total Invoice Amount: {{unpaidInvoiceReportStats.filteredTotalAmount}}</div>
					    <div style="color: #757575">
						    The Filtered Total Invoice Amount removes all invoices that meet the following criteria
						    <ul>
							    <li>The Invoice is for a DISABLED Organization</li>
							    <li>The Invoice has been VOIDED</li>
							    <li>The Invoice is not past due</li>
						    </ul>
					    </div>
					    
				    </div>
			    </div>
			
			    <div v-if="currentReport === 3" >
				    <div>There are currently <strong style="color: #07aaf4">{{reportRows.length}}</strong> Missing Invoices</div>
				    
				    <div class="pt-2">
					    <div style="font-weight: bold">Missing Invoice Report Description</div>
					    <p>The Missing Invoice Report shows all organizations that have not had an invoice created in over a year.</p>
				    </div>
				    <div style="display: flex; gap: .25rem">
					    <div>Organization Name: </div>
					
					    <app-chip color="purple" label small>Research</app-chip>
					    <app-chip color="green" label small>Demo</app-chip>
					    <app-chip color="red" label small>Disabled</app-chip>
				    </div>
				    <div style="display: flex; gap: .25rem" class="pt-2">
					    <div>Last Invoice Date: </div>
					    <app-chip color="blue" label small>days ago</app-chip>
				    </div>
			    </div>
			
			    <div v-if="currentReport === 4" >
				    <div>There are currently <strong style="color: #07aaf4">{{reportRows.length}}</strong> Unsent Invoices</div>
				    
				    <div class="pt-2">
					    <div style="font-weight: bold">Unsent Invoice Report Description</div>
					    <p>The Unsent Invoice Report shows all invoices that have been created but not sent to the customer through the portal.</p>
				    </div>
				    <div style="display: flex; gap: .25rem">
					    <div>Invoice Type: </div>
					    <InvoiceTypeChip :invoice-type-id="1" small />
					    <InvoiceTypeChip :invoice-type-id="2" small />
					    <InvoiceTypeChip :invoice-type-id="3" small />
                        <InvoiceTypeChip :invoice-type-id="4" small />
                        <InvoiceTypeChip :invoice-type-id="5" small />
				    </div>
				    <div style="display: flex; gap: .25rem" class="pt-2">
					    <div>Due Date: </div>
					
					    <app-chip color="red" label small>days past due</app-chip>
					    <app-chip color="green" label small>today</app-chip>
					    <app-chip color="blue" label small>days out</app-chip>
				    </div>
				    <div style="display: flex; gap: .25rem" class="pt-2">
					    <div>Display Date: </div>
					
					    <app-chip color="red" label small>days past due</app-chip>
					    <app-chip color="green" label small>today</app-chip>
					    <app-chip color="blue" label small>days out</app-chip>
				    </div>
				    <div style="display: flex; gap: .25rem" class="pt-2">
					    <div>Approval Status: </div>
					    <InvoiceApprovalStatusChip :approval-status-id="0" small/>
					    <InvoiceApprovalStatusChip :approval-status-id="1" small/>
					    <InvoiceApprovalStatusChip :approval-status-id="2" small/>
					    <InvoiceApprovalStatusChip :approval-status-id="3" small/>
				    </div>
			    </div>

			    <div v-if="currentReport === 5" >
				    <div>There are currently <strong style="color: #07aaf4">{{reportRows.length}}</strong> Shadow Invoices</div>

				    <div class="pt-2">
					    <div style="font-weight: bold">Shadow Invoice Report Description</div>
					    <p>The Shadow Invoice Report shows all shadow invoices — internal record-keeping invoices created when DisableAutoPrePayInvoiceCreation is on. These are never sent, displayed to customers, or synced to QuickBooks.</p>
				    </div>
			    </div>

		    </app-card>
		    
	    </div>
        

		<app-card hide-header v-if="currentReport">
			<div class="pa-4" style="display: flex; align-items: center; gap: 1rem">
				<v-text-field
					v-model="searchQuery"
					prepend-inner-icon="mdi-magnify"
					label="Search"
					variant="outlined"
					density="compact"
					hide-details
					clearable
					style="max-width: 320px"
				/>
				<div style="color: #757575; font-size: 0.875rem">
					Showing {{ reportRows.length }} row<span v-if="reportRows.length !== 1">s</span>
				</div>
			</div>
			<v-data-table
				:items="reportRows"
				:headers="headers"
				:search="searchQuery"
				:show-expand="showExpand"
				@click:row="(event, { item, toggleExpand, isExpanded }) => showExpand ? toggleExpand(item) : null"
				id="invoices-table"
				ref="invoices-table"
				single-expand
				v-model:options="options"
				:item-key="currentReport === 4 ? 'id' : currentReport === 5 ? 'ShadowInvoiceId' : 'InvoiceId'"
				:sort-by="sortBy"
				:items-per-page="itemsPerPage"
				:items-per-page-options="itemsPerPageOptions"
			>
				
				<template v-slot:item.id="{ item }">
					{{item.id}} 
					<AppChip small label v-if="item.deletedOn" color="red" >VOID</AppChip>
				</template>
				
				<template v-slot:item.DueDate="{ item }" v-if="currentReport === 2 || currentReport === 4">
					{{ item.DueDate }}
					<InvoiceDaysTillChip v-if="item.daysTillDue" :value="item.daysTillDue" />
				
				</template>
				
				<template v-slot:item.dueDate="{ item }" v-if="currentReport === 2 || currentReport === 4">
					{{ item.dueDate }}
					<InvoiceDaysTillChip v-if="currentReport === 2" :value="item.daysTillDue" />
				
				</template>
				
				<template v-slot:item.organizationId="{item}">
					{{item.organizationInfo.organizationId }}
				</template>
				<template v-slot:item.organizationName="{item}">
					{{item.organizationInfo.organizationName }}
				</template>
				
				<template v-slot:item.approvalStatusId="{ item }">
					<InvoiceApprovalStatusChip :approval-status-id="item.approvalStatusId" />
				</template>
				
				<template v-slot:item.Name="{ item }" v-if="currentReport === 2 || currentReport === 3 || currentReport === 5">
					{{item.Name}}
					<app-chip
						v-if="item.IsResearch"
						color="purple"
						label
						class="ml-2"
						small
					>
						Research
					</app-chip>
					<app-chip
						v-if="item.IsDemo"
						color="green"
						label
						class="ml-2"
						small
					>
						Demo
					</app-chip>
					<app-chip
						v-if="item.IsDisabled"
						color="red"
						label
						class="ml-2"
						small
					>
						Disabled
					</app-chip>
				</template>
				
				<template v-slot:item.LastInvoiceDate="{ item }" v-if="currentReport === 3">
					{{item.LastInvoiceDate}}
					<app-chip
						color="blue"
						label
						class="ml-2"
						small
					>
						{{ item.daysSinceLastInvoice }} days ago
					</app-chip>
					
				</template>
				
				<template v-slot:item.DisplayDate="{ item }" v-if="currentReport === 2 || currentReport === 4">
					{{ item.displayDate }}
					<app-chip
						v-if="item.daysTillDisplayDate"
						:color="item.daysTillDisplayDate > 0 ? 'red' : item.daysTillDisplayDate == 0 ? 'green' : 'blue' "
						label
						class="ml-2"
						small
					>
						{{ item.daysTillDisplayDate !== 0 ? Math.abs(item.daysTillDisplayDate) : 'today' }} {{ item.daysTillDisplayDate > 0 ? 'days past due' : item.daysTillDisplayDate < 0 ? 'days out' : null }}
					</app-chip>
				
				</template>
				
				<template v-slot:item.displayDate="{ item }" v-if="currentReport === 2 || currentReport === 4">
					{{ item.displayDate }}
					<app-chip
						v-if="item.daysTillDisplayDate"
						:color="item.daysTillDisplayDate > 0 ? 'red' : item.daysTillDisplayDate == 0 ? 'green' : 'blue' "
						label
						class="ml-2"
						small
					>
						{{ item.daysTillDisplayDate !== 0 ? Math.abs(item.daysTillDisplayDate) : 'today' }} {{ item.daysTillDisplayDate > 0 ? 'days past due' : item.daysTillDisplayDate < 0 ? 'days out' : null }}
					</app-chip>
				
				</template>
				
				<template v-slot:item.invoiceTypeId="{ item }" v-if="currentReport === 4">
					<InvoiceTypeChip :invoice-type-id="item.invoiceTypeId" />				
				</template>

				
				<template v-slot:item.link="{ item }">
					<div @click="onRowClick(item)">
						<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M15.3089 18.8397H2.35521C1.05396 18.8397 0 17.7858 0 16.4847V3.53244C0 2.23132 1.05396 1.17748 2.35521 1.17748H7.06563V3.53244H2.35521V16.4847H15.3089V11.7748H17.6641V16.4847C17.6641 17.7858 16.6101 18.8397 15.3089 18.8397ZM9.06757 11.4298L7.40718 9.76487L14.8178 2.35496H10.5984V0H18.8417V8.24235H16.4865V4.02106L9.06757 11.4298Z" fill="#CCCCCC"/>
						</svg>
					
					</div>
				</template>
				
				<template v-slot:expanded-item="{ headers, item }" >
					<td :colspan="headers.length" style="background-color: #fafafa">
						<UnsentInvoicesDetails v-if="currentReport === 4" :invoice="item"/>
					</td>
				
				</template>
				
				
			</v-data-table>
			
		</app-card>
	    

        
    </div>
</template>

<script>
import {getInvoiceReportExport, getUnpaidInvoiceReportExport, getMissingInvoiceReportExport, getUnsentInvoiceReportExport, getShadowInvoiceReportExport,
    getInvoiceReport, getUnpaidInvoiceReport, getMissingInvoiceReport, getUnsentInvoiceReport, getShadowInvoiceReport} from "@/services/report.service";

import moment from "moment";
import UnsentInvoicesDetails from "@/components/Reporting/InvoiceReports/UnsentInvoicesDetails";
import {invoiceApprovalStatuses} from "@/js/shared/constants";
import Invoice from "@/js/shared/classes/Invoice/Invoice";
import InvoiceApprovalStatusChip from "@/components/Billing/Chips/InvoiceApprovalStatusChip";
import InvoiceTypeChip from "@/components/Billing/Chips/InvoiceTypeChip";
import InvoiceDaysTillChip from "@/components/Billing/Chips/InvoiceDaysTillChip";
import {formatMoney} from "@/js/shared/helper";

export default {
    name: "InvoiceReports",
    components: {
	    InvoiceDaysTillChip,
	    InvoiceTypeChip,
	    InvoiceApprovalStatusChip,
	    UnsentInvoicesDetails
    },
    data () {
        return {
            headers: [],
	        options: {},
	        searchQuery: '',
	        itemsPerPage: 25,
	        itemsPerPageOptions: [
		        { value: 25, title: '25' },
		        { value: 50, title: '50' },
		        { value: 100, title: '100' },
		        { value: 250, title: '250' },
		        { value: -1, title: 'All' }
	        ],
            reportRows: [],
            loading: true,
	        sortBy: [], // Vuetify 3: array of { key, order } objects
	        unpaidInvoiceHeaders: [
		        {
			        title: "Invoice ID",
			        value: "InvoiceId"
		        },
		        {
			        title: "Org ID",
			        value: "OrganizationId"
		        },
		        {
			        title: "Org Name",
			        value: "Name"
		        },
		        {
			        title: "Issued On",
			        value: "IssuedOn"
		        },
		        {
			        title: "Due Date",
			        value: "DueDate"
		        },
		        {
			        title: "Deleted On",
			        value: "DeletedOn"
		        },
		        {
			        title: "Invoice Total",
			        value: "InvoiceTotal"
		        },
		        {
			        title: "Total Paid",
			        value: "TotalPaid"
		        },

                // {
                //     text: "Is Disabled",
                //     value: "IsDisabled"
                // },
                // {
                //     text: "Is Research",
                //     value: "IsResearch"
                // },
                // {
                //     text: "Is Demo",
                //     value: "IsDemo"
                // },
		        {
			        "title": " ",
			        "value": "link"
		        },
	        ],
	        missingInvoiceHeaders: [
		        {
					title: "Org ID",
			        value: "OrgId"
		        },
		        {
			        title: "Name",
			        value: "Name"
		        },
		        {
			        title: "Last Invoice Date",
			        value: "LastInvoiceDate"
		        },
		        {
			        title: "Org Deleted Date",
			        value: "OrgDeletedDate"
		        },
	        ],
	        unsentInvoiceHeaders: [
		        {
			        "title": "ID",
			        "value": "id"
		        },
		        {
			        "title": "Org Id",
			        "value": "organizationId"
		        },
		        {
			        title: "Invoice Type",
			        value: "invoiceTypeId"
		        },
		        {
			        "title": "Org Name",
			        "value": "organizationName"
		        },
		        {
			        "title": "Amount",
			        "value": "total"
		        },
		        {
			        "title": "Due Date",
			        "value": "dueDate"
		        },
		        {
			        "title": "Display Date",
			        "value": "displayDate"
		        },
		        // {
			    //     "text": "Renewal Date",
			    //     "value": "CurrentRenewalDate"
		        // },
                {
                    "title": "Approval Status",
                    "value": "approvalStatusId"
                },
		        {
			        "title": " ",
			        "value": "link"
		        },
	        ],
	        shadowInvoiceHeaders: [
		        {
			        title: "Shadow Invoice ID",
			        value: "ShadowInvoiceId"
		        },
		        {
			        title: "Org ID",
			        value: "OrganizationId"
		        },
		        {
			        title: "Org Name",
			        value: "Name"
		        },
		        {
			        title: "Invoice Type",
			        value: "invoiceTypeId"
		        },
		        {
			        title: "Issued On",
			        value: "IssuedOn"
		        },
		        {
			        title: "Display Date",
			        value: "DisplayDate"
		        },
		        {
			        title: "Due Date",
			        value: "DueDate"
		        },
		        {
			        title: "Deleted On",
			        value: "DeletedOn"
		        },
		        {
			        title: "Invoice Total",
			        value: "InvoiceTotal"
		        },
		        {
			        title: "Approval Status",
			        value: "approvalStatusId"
		        }
	        ],
			currentReport: 0, // 0 = none, 1 = Invoice Report, 2 = Unpaid Invoice Report, 3 = Missing Invoice Report, 4 = Unsent Invoice Report, 5 = Shadow Invoice Report
	        invoiceApprovalStatuses,
	        unpaidInvoiceReportStats: null,
	        runningReport: null
        }
    },

    mounted () {
        //this.getDataFromApi()
    },
    watch: {
        // Reset search when switching between reports — otherwise a term from one
        // report keeps filtering the next report's rows.
        currentReport() {
            this.searchQuery = '';
        }
    },
    methods: {
        async getInvoiceReport() {
            this.runningReport = 'invoice';
            try {
                const response = await getInvoiceReport();
                this.currentReport = 1
                // WebReportModelDynamic returns { Text, Value } (legacy Vuetify 2 shape).
                // Vuetify 3's v-data-table needs { title, value } — without the rename
                // it silently renders rows with no header row.
                this.headers = (response.headers || []).map(h => ({
                    title: h.text ?? h.Text,
                    value: h.value ?? h.Value,
                }));
                this.reportRows = response.report;
            } finally {
                this.runningReport = null;
            }
        },
        async getUnpaidInvoiceReport() {
            this.runningReport = 'unpaid';
            try {
            const response = await getUnpaidInvoiceReport();
	        this.currentReport = 2
            this.headers = this.unpaidInvoiceHeaders;
			
			let unpaidInvoiceReportStats = {
				totalAmount: 0,
				filteredTotalAmount: 0
			}

			
			let filteredRows = []
	
	        response.report.forEach((x, index) => {
				
				// x = new Invoice(x)
				
		        x.daysSinceLastInvoice = moment().diff(x.LastInvoiceDate, 'days')
		        
		        x.daysTillDue = x.DueDate ? moment().diff(x.DueDate, "days") * -1 : null;
				
		        // x.DaysPastDue = moment().isAfter(x.DueDate) ? moment().diff(x.DueDate, "days") : null;
		
		
		        unpaidInvoiceReportStats.totalAmount += x.InvoiceTotal
				
				if (x.daysTillDue < 0 && !x.DeletedOn && !x.IsDisabled) {
					unpaidInvoiceReportStats.filteredTotalAmount += x.InvoiceTotal
					
					filteredRows.push(x)
				}
		
		        x.InvoiceTotal = `$${x.InvoiceTotal}`;
		        x.TotalPaid = `$${x.TotalPaid}`;
		        x.IssuedOn = moment(x.IssuedOn).format("YYYY-MM-DD");
		        x.DueDate = x.DueDate ? moment(x.DueDate).format("YYYY-MM-DD") : null;
		        x.Name = x.OrganizationName;
				
	        })
	        
	        // let rows = response.report
	        
			unpaidInvoiceReportStats.totalAmount = formatMoney(unpaidInvoiceReportStats.totalAmount)
			unpaidInvoiceReportStats.filteredTotalAmount = formatMoney(unpaidInvoiceReportStats.filteredTotalAmount)
			this.unpaidInvoiceReportStats = unpaidInvoiceReportStats;		
	        
            this.reportRows = response.report;
            } finally {
                this.runningReport = null;
            }
        },
        async getMissingInvoiceReport() {
            this.runningReport = 'missing';
            try {
            const response = await getMissingInvoiceReport();
	        this.currentReport = 3
            this.headers = this.missingInvoiceHeaders;
			
			response.report.forEach(x => {
				
				
				x.daysSinceLastInvoice = moment().diff(x.LastInvoiceDate, 'days')
				x.LastInvoiceDate = moment(x.LastInvoiceDate).format("YYYY-MM-DD")
				x.OrgDeletedDate = x.OrgDeletedDate ? moment(x.OrgDeletedDate).format("YYYY-MM-DD") : null
				
			})
			
            this.reportRows = response.report;
	
	        // Vuetify 3: sortBy is array of { key, order } objects
	        this.sortBy = [{ key: 'LastInvoiceDate', order: 'desc' }]
            } finally {
                this.runningReport = null;
            }
        },
        async getUnsentInvoiceReport() {
            this.runningReport = 'unsent';
            try {
            const response = await getUnsentInvoiceReport();
            // this.headers = response.headers;
	        this.currentReport = 4

            this.headers = this.unsentInvoiceHeaders;

			let data = response.report.map(x => new Invoice(x))

	        // Vuetify 3: sortBy is array of { key, order } objects
	        this.sortBy = [{ key: 'displayDate', order: 'asc' }]


            this.reportRows = data;
            } finally {
                this.runningReport = null;
            }
        },
        async getShadowInvoiceReport() {
            this.runningReport = 'shadow';
            try {
                const response = await getShadowInvoiceReport();
                this.currentReport = 5
                this.headers = this.shadowInvoiceHeaders;

                response.report.forEach(x => {
                    x.IssuedOn = x.IssuedOn ? moment(x.IssuedOn).format("YYYY-MM-DD") : null;
                    x.DueDate = x.DueDate ? moment(x.DueDate).format("YYYY-MM-DD") : null;
                    x.DisplayDate = x.DisplayDate ? moment(x.DisplayDate).format("YYYY-MM-DD") : null;
                    x.DeletedOn = x.DeletedOn ? moment(x.DeletedOn).format("YYYY-MM-DD") : null;
                    x.InvoiceTotal = `$${x.InvoiceTotal}`;
                    x.Name = x.OrganizationName;
                })

                this.sortBy = [{ key: 'IssuedOn', order: 'desc' }]
                this.reportRows = response.report;
            } finally {
                this.runningReport = null;
            }
        },
        async downloadInvoiceReport() {
            this.runningReport = 'download-invoice';
            try {
                await getInvoiceReportExport();
            } finally {
                this.runningReport = null;
            }
        },
        async downloadUnpaidInvoiceReport() {
            this.runningReport = 'download-unpaid';
            try {
                await getUnpaidInvoiceReportExport();
            } finally {
                this.runningReport = null;
            }
        },
        async downloadMissingInvoiceReport() {
            this.runningReport = 'download-missing';
            try {
                await getMissingInvoiceReportExport();
            } finally {
                this.runningReport = null;
            }
        },
        async downloadUnsentInvoiceReport() {
            this.runningReport = 'download-unsent';
            try {
                await getUnsentInvoiceReportExport();
            } finally {
                this.runningReport = null;
            }
        },
        async downloadShadowInvoiceReport() {
            this.runningReport = 'download-shadow';
            try {
                await getShadowInvoiceReportExport();
            } finally {
                this.runningReport = null;
            }
        },
	    async onRowClick(item) {
			
			if (this.currentReport === 4) {
				window.open(`${window.location.origin}/billing/create-invoice?orgId=${item.organizationInfo.organizationId}&id=${item.id}`, '_blank')
			} else {
				window.open(`${window.location.origin}/billing/create-invoice?orgId=${item.OrganizationId}&id=${item.InvoiceId}`, '_blank')
			}
		    
	    }
    },
	computed: {
		showExpand() {
			return this.currentReport === 4
		}
	}
}
</script>

<style scoped>

</style>